<template>
  <v-dialog
      class="hide-on-print"
      persistent
      v-model="innerOpen"
      width="800">
    <v-card class="hide-on-print">
      <v-toolbar color="blue darken-3" dark>
        <v-toolbar-title>Forward To User</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pa-0">
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-form class="pa-2" lazy-validation ref="formRef">
                <v-layout row wrap>
                  <v-flex class="py-0" xs12>
                    <v-autocomplete
                        :rules="[rules.required]"
                        :items="users"
                        item-text="full_name"
                        item-value="id"
                        label="Select User"
                        outlined
                        v-model="formData.assignee_id"
                    />
                  </v-flex>
                  <v-flex class="py-0" xs12 v-if="purpose && purpose !== 6">
                    <v-autocomplete
                        :rules="[rules.required]"
                        :items="forwardPurposes"
                        item-text="label"
                        item-value="value"
                        label="Select Purpose"
                        outlined
                        v-model="formData.purpose"
                    />
                  </v-flex>
                  <v-flex class="py-0" xs12>
                    <v-textarea
                        :rules="[rules.required]"
                        label="Remarks *"
                        outlined
                        v-model="formData.remarks"
                        type="textarea"
                        rows="3"
                    ></v-textarea>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider style="margin-top:31px;"/>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancelTippaniAssign" class="white--text" color="red lighten-1">
          Cancel
        </v-btn>
        <v-btn
            @click="assignUser"
            class="white--text"
            color="blue darken-3"
        >Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {validationMixin} from "@/mixins/validationMixin";
import {mapActions, mapGetters} from "vuex";
import _ from "lodash";
import {FORWARD_CERTIFICATION, GET_VISA_CERTIFICATION} from "../../store/action-type";

export default {
  name: "CertificationForwardDialog",
  components: {},
  props: ['value', 'purpose',"submissionNo"],
  mixins: [validationMixin],
  data() {
    return {
      innerOpen: false,
      remarks: "",
      forwardPurposes: [
        {label: 'Tippani Approve', value: 2},
        {label: 'Tippani Verify', value: 0},
        // {label: 'Penalty', value: 1},
      ],
      formData: {}
    }
  },
  computed: {
    ...mapGetters("TrekkingSingle", ["trekkingData", "loading"]),
    users() {
      return this.$store.state.VisaRequestSingle.officeWiseUsers;
    },
    loading: {
      get() {
        return this.$store.state.AuthUser.loading;
      },
      set(value) {
        this.$store.commit('AuthUser/setLoading', value)
      }
    },
  },
  watch: {
    value(input) {
      this.innerOpen = input;
      if(this.purpose) {
        this.$set(this.formData, 'purpose', this.purpose)
      }
    },
    innerOpen(value) {
    }
  },
  methods: {
    ...mapActions("TrekkingSingle", ["forwardUser"]),
    resetForwardForm(){
      this.formData = {}
    },
    cancelTippaniAssign() {
      this.innerOpen = false;
      this.$emit('input', false)
    },
    async assignUser() {
      let text = "Are you sure you want to assign user for  tippani ? Tippani once assigned cannot be reassign.If you click no by mistakely. You have to delete tippani and generate new one and reassign user"
      if (this.formData.purpose) {
        if(this.formData.purpose === 6){
          text = "Are you sure you want to assign user? Once assigned cannot be reassign."
        } else {
          const purpose = _.find(this.forwardPurposes, ['value', this.formData.purpose]).label
          text = "Are you sure you want forward to user for " + purpose + "?"
        }
      }
      await this.$dialog.confirm({
        text: text,
        actions: {
          false: "No",
          true: {
            text: "Yes",
            handle: async () => {
              if (this.$refs.formRef.validate()) {
                this.$store.dispatch(FORWARD_CERTIFICATION, this.formData).then(() => {
                  this.$store.commit('Notification/showSuccess', 'Forwarded to user successfully');
                  this.$store.dispatch(GET_VISA_CERTIFICATION, this.submissionNo)
                  this.innerOpen = false;
                  this.resetForwardForm()
                  this.$emit('input', false)
                }).catch(error => {
                  this.$store.commit('Notification/showError', error.response.data.message);
                  this.innerOpen = false;
                  this.$emit('input', false)
                  return;
                })
              } else {
                this.$store.commit("Notification/showError", "Invalid Form Data");
              }
            }
          }
        }
      });
    },
  },
  async mounted() {
    if (this.value) {
      this.innerOpen = this.value;
    }

    if (!this.$store.state.VisaRequestSingle.officeWiseUsers.length) {
      this.$store.dispatch("VisaRequestSingle/getOfficeWiseUser")
    }
  }
}
</script>
